module.exports = __webpack_public_path__ + "img/lotus_orb.19785ddd.png";